import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../../api/userApi';
import { useTranslation } from 'react-i18next';
import HomeButton from '../common/HomeButton';
import './ResetPassword.css';
import { isPasswordValid } from '../../utils/authenticationUtils';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        if (!isPasswordValid(newPassword)) {
            setError(t('resetPassword.errorInvalidPassword'));
            return;
        }
        if (newPassword !== confirmPassword) {
            setError(t('resetPassword.errorDoNotMatch'));
            return;
        }

        try {
            await resetPassword({
                token: searchParams.get('token'),
                newPassword,
            });
            setMessage(t('resetPassword.success'));
            setTimeout(() => navigate('/login'), 3000);
        } catch (error) {
            setError(t('resetPassword.errorFailed'));
        }
    };

    return (
        <div className="reset-password-component">
            <HomeButton />
            <h2>{t('resetPassword.title')}</h2>
            <form className='reset-password-form' onSubmit={handleSubmit}>
                <input
                    type="password"
                    value={newPassword}
                    placeholder={t('resetPassword.newPassword')}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                />
                <input
                    type="password"
                    value={confirmPassword}
                    placeholder={t('resetPassword.passwordConfirmation')}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
                <button className='big-button action-button' type="submit">{t('resetPassword.savePassword')}</button>
            </form>
            {message && <p className="message">{message}</p>}
            {error && <p className='form-error'>{error}</p>}
        </div>
    );
};

export default ResetPassword;
